export const convertFileSize = size => {
  const i = Math.floor( Math.log(size) / Math.log(1024) );
  const units =  ['B', 'kB', 'MB', 'GB', 'TB'];
  return ( size / Math.pow(1024, i) ).toFixed(2) * 1 + ' ' + units[i];
};

